import React, { useState , useEffect } from "react";
// import axios from "axios";
import "./OtpCode.css";
import OTPInput from "react-otp-input";
import otp_side from "../../assets/forms/side_otp_img.png";
import side_img from "../../assets/gamerclub our marketplace-03.png";
import { Link, useNavigate } from "react-router-dom";
import { saveTracker,setAgencyData } from "../../Utilies/gamerClubApi";
import { Col, Row } from "react-bootstrap";
import FormsAside from "../../Components/FormsAside/FormsAside";
import { notify } from "../../Components/ToastComponent";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import queryString from "query-string";
import { axios } from "./../../api/axiosInterceptor";

const SignUpNewdzo = () => {
  localStorage.setItem('i18nextLng','ar');
  const { t } = useTranslation();
  const navigate = useNavigate();
  // lodaing state
  const [lodaing, setLodaing] = useState(true);
  // errors messages state
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [showSignUp, setShowSignUp] = useState(false);
    const [showPinFlow, setShowPinFlow] = useState(false);

  const [otp, setOtp] = useState("");
  const [transactionidentify,setTransactionidentify] = useState("");
  const [transactionid,setTransactionid] = useState("");
  const [showLoading, setshowLoading] = useState(false);
  const [showSub, setshowSub] = useState(false);
  const [showPendding, setshowPendding] = useState(true);
  const [phonenumber , setphonenumber] = useState("");
  const [sub_id , setsub_id] = useState("");
  const [errorMesg, setErrorMesg] = useState(false);
  const [errorMesgSubscribe, setErrorMesgSubscribe] = useState("");
  const [errorresverify, seterrorresverify] = useState("");
  const [activeData, setActiveData] = useState("");
  const [checkPhone, setCheckPhone] = useState(false);
  const [showverif, setShowverif] = useState(false);

  const [agree, setagree] = useState(false);

  // user state
  const [formData, setFormData] = useState({
    phone: "",
    first_name: "",
    last_name: "",
    email: "",
  });


  useEffect(() => {
   
    localStorage.setItem('i18nextLng','ar');

   
    const params = queryString.parse(window.location.search);
    if (params.lang) {
     //console.log("lang",params.lang);
      localStorage.setItem("i18nextLng", params.lang);
      if(localStorage.getItem("i18nextLng") != params.lang){
        localStorage.setItem("i18nextLng", params.lang);
        window.location.reload();
      }
      //window.location.reload();
      //localLang.checklocalLanguage();
    }
    setAgencyData(params);
     if(params.camp){
       setagree(true)
      }
    const path = window.location.pathname;
    if (path.includes("procedding2")) {
      checkoutTransaction(params);
    }else if (path.includes("signUp")) {
      setShowSignUp(true);
    }
 
    getScript();

  }, []);


  async function getRedirectURL(){
    const transaction = localStorage.getItem('transaction');
    const time = localStorage.getItem('time');
     const body = {transaction: transaction , time: time};
   const url = `https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/checkout`;
    await axios.post(url ,body)
    .then(response => {
    
       const url = response.data.url;
       if(url !=="" && url != null){
         
           window.location.href=url;
       }
      
      
    })
    .catch(error=> {
      console.log(error);
      
    })
    
  }











    // get form inputs values
  function getFormData({ target }) {
    
    //console.log(target.value.replace(/[^0-9]/g, ""));
    setActiveData(target.value.replace(/[^0-9]/g, ""));
//    setphonenumber(target.value.replace(/[^0-9]/g, ""));
    setshowSub(false);
    setFormData({
      ...formData,
      [target.name]: target.value,
    });
  }




  const Subscribe = async e => {
         e.preventDefault();

         const phoneInput = e.target.phone;
        
       
         const phone_number_val = phoneInput.value;
         setActiveData(phone_number_val);
     
     if (phone_number_val) {
      console.log('phone')
       var phon_n = phone_number_val.toString();
       const url = `https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/subscribe`
       setLodaing(false);
       await axios.post(url , { phone: phon_n })
         .then(res => {
           if (res.data.success === true) {
             setShowverif(true)
           }
           else {
             if (res.data.message != null) {
               setErrorMsg(res.data.message); 
             }
              else if (res.data.blacklisted ) {  
        
          setErrorMsg('ce numéro de téléphone est sur liste noire, veuillez en utiliser un autre')
          
          }
             else {
              setErrorMsg(t("Something went wrong! Please make sure you have the correct number inserted or try again later.")); 
             }
            // setShowverif(true) 
 
           }
           setLodaing(false);
 
         })
         .catch(function (error) {
           setErrorMesg(true)
           setShowverif(false)
         })
         .finally(function () {
          //console.log('complete');
         });
 
 
     }
   };
 
 
   const verify = async e => {
     e.preventDefault();
     if (otp) {
       var phon_n = activeData;
       setLodaing(false);
       const transaction = localStorage.getItem('transaction');
    const time = localStorage.getItem('time');
       axios.post(`https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/verify` , { phone: phon_n, otp: otp  , transaction: transaction , time: time})
         .then(res => {
          //console.log(res);
          setLodaing(true);
           if (res.data.success == true) {
           
            notify("OTP Code Is Correct");
            setTimeout(() => {
              navigate("/success", { replace: true });
            }, 2500);
                
           } else {
             if (res.data.message != null) {
              setErrorMsg(res.data.message);
               //setVerfiErrorMesg(true);
 
             }
             else if (res.data.blacklisted ) {  
        
          setErrorMsg('ce numéro de téléphone est sur liste noire, veuillez en utiliser un autre')
          
          }
             else {
              setErrorMsg(t("Something went wrong! Please make sure you have the correct verification code inserted or try again later."));
               //----setVerfiErrorMesg(true);
 
 
             }
    
           }
           setLodaing(true);
 
         })
         .catch(function (error) {
          //console.log(error);

              setErrorMsg(error.error.data.message);
 
         })
         .finally(function () {
 
          //console.log('complete');
         });
     }
   };
 
async function getScript() {
  const path = window.location.pathname;

  let type = '';
  if (path.includes('signUp')) {
    type = 'he';
  } else if (path.includes('procedding2')) {
    type = 'pin';
  }

  const url = `https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/antifraud?id=signupbut&type=${type}`;

  try {
    const res = await axios.post(url);
  
    if (res.data.success === true) {
      const addScript = document.createElement('script');
      addScript.innerHTML = res.data.data.script;
      document.head.appendChild(addScript);
     localStorage.setItem('transaction', res.data.data.transaction);
     localStorage.setItem('time', res.data.data.time);

      var event = new Event('DCBProtectRun');
      document.dispatchEvent(event);
    } else {
      setErrorMesg(true);
      setErrorMesgSubscribe(res.data.data.message);
    }
  } catch (error) {
    console.error(error);
    // setErrorMesg(true);
  } finally {
    setLodaing(false);
  }
}
async function checkoutTransaction(payload) {
   const body={
    ...payload,
    company: localStorage.getItem('trackerCompany'),
    key: localStorage.getItem('tracker'),
   }
  const url = `https://vas1.grand-hub.com/api/gamerClub/ooredoo-alg-d-migrat/check`;

  try {
    const res = await axios.post(url , body);
  
    if (res.data.success === true) {
      localStorage.setItem('phone', res.data.phone);
      console.log(res.data);
       navigate("/success");
    } else {
       setShowSignUp(true);
       setShowPinFlow(true);
    }
  } catch (error) {
          setShowSignUp(true);
                 setShowPinFlow(true);


  } finally {
    setLodaing(false);
  }
}
  // send data to the server
  function sendData(e) {
    e.preventDefault();
     const path = window.location.pathname;
    if (path.includes("procedding2")) {
      Subscribe(e);
    }else if (path.includes("signUp")) {
     getRedirectURL();
    }
 

  }
  const verifyOtp = async () => {
    try {
      setLodaing(false);
      // let formData = {
      //   phone: phone_number,
      //   otp: otp,
      // };
      // let result = await linkOtpCode(formData);
      // console.log(result);
      // // success alert message
      notify("OTP Code Is Correct");
      // localStorage.setItem("user_id", result?.user?.id);
      // // store token to local storage
      // localStorage.setItem("token", result?.access_token);
      // localStorage.setItem("userImage", JSON.stringify(result?.user?.avatar));
      notify("OTP Code Is Correct");
      setTimeout(() => {
        navigate("/success", { replace: true });
      }, 2500);
    } catch (error) {
      if (error) {
        //notify1(error?.response?.data?.message);
      }
      setLodaing(true);
      setOtp("");
    }
  };


 return (
  <>
    {showSignUp && (
      <div className="signUp">
        <ToastContainer />
        <Row
          className="mx-0"
          dir={localStorage.getItem("i18nextLng") === "ar" ? "rtl" : "ltr"}
        >
          <FormsAside side_img={side_img} />
          <Col xs={12} md={7} lg={8} xl={8} className="form">
            <Row className="h-20" style={{ paddingTop: "10%" }}>
              <Col className="m-auto" xs={12} md={8} lg={6}>
                {successMsg && (
                  <div className="text-left alert alert-success ">
                    <p>{successMsg}</p>
                  </div>
                )}

                {errorMsg && (
                  <div className="text-left alert alert-danger">
                    <p>{errorMsg}</p>
                  </div>
                )}

                {!showverif ? (
                  <>
                    <h1 style={{ color: "white" }}>{t("create account")}</h1>

                    <form className="signUp-form" onSubmit={sendData}>
                      {showPinFlow && (
                          <div className="w-100 d-flex justify-content-between">
                        <input
                          name="phone"
                          value={activeData}
                          onChange={getFormData}
                          className="form-control ms-2 phone"
                          type="tel"
                          style={{ width: "80%" }}
                          placeholder={t("phone")}
                          required
                        />
                        <input
                          type="text"
                          value="+213"
                          style={{ width: "21%", direction: "ltr" }}
                          name="countryCode"
                          className="form-control"
                          readOnly
                        />
                      </div>
                      )}
                    
                      <button
                        disabled={!agree}
                        type="submit"
                        id="signupbut"
                        className="btn-submit"
                      >
                        {lodaing ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          t("create account")
                        )}
                      </button>
                    </form>

                    <div className="submit-info my-5">
                      <div className="d-flex align-items-center justify-content-center ">
                        <h6 className="form-check-label mb-0 fw-bold text-white">
                          Acceptation des termes et conditions
                        </h6>
                        <input
                          type="checkbox"
                          className="form-check-input mt-0 me-2 check-box "
                          onChange={() => setagree(!agree)}
                          checked={agree}
                        />
                      </div>

                      <div className="text-white">
                        <p className="text-center text-white fw-medium mb-0 mt-4">
                          Remarque : Vous serez abonné à Gamer Club avec votre
                          numéro de téléphone actuel
                        </p>
                        <p className="text-center fw-medium mb-0">
                          Les frais d'abonnement sont de 35,00 DZD par jour
                        </p>
                        <p className="text-center fw-medium mb-0">
                          Pour plus d'informations, veuillez nous contacter à
                          support@grandmstg.com{" "}
                        </p>
                      </div>
                      <h3 className="text-white">
                        {t("Already Have Account?")}{" "}
                        <Link className="text-white" to="/signin">
                          {t("signin")}
                        </Link>
                      </h3>
                    </div>
                  </>
                ) : null}

                {showverif && (
                  <>
                    <OTPInput
                      inputType="number"
                      containerStyle={{
                        justifyContent: "center",
                        direction: "ltr",
                      }}
                      inputStyle={{
                        width: "40px",
                        height: "50px",
                        justifyContent: "space-between",
                        border: "2px solid black",
                        direction: "ltr",
                      }}
                      value={otp}
                      onChange={setOtp}
                      numInputs={6}
                      renderSeparator={<span>-</span>}
                      renderInput={(props) => <input required {...props} />}
                      shouldAutoFocus={true}
                    />

                    <div className="submit-info">
                      <button
                        onClick={(e) => verify(e)}
                        className="btn-submit w-100"
                      >
                        {lodaing ? (
                          <i className="fas fa-spinner fa-spin"></i>
                        ) : (
                          t("Verify Otp")
                        )}
                      </button>
                    </div>
                  </>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    )}
  </>
);

};

export default SignUpNewdzo;
